(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/error/external-message-error.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/error/external-message-error.js');
"use strict";


const logger = svs.components.payment.common.logger;
const HasCareTechRestriction = svs.caretech.caretech_restrictions.HasCareTechRestriction;
const showExternalErrorMessage = async errorCodes => {
  let errorHandled = false;
  if (errorCodes) {
    try {
      errorHandled = HasCareTechRestriction('pools');
    } catch (err) {}
  }
  return errorHandled;
};
setGlobal('svs.components.payment.common.error.ExternalErrorMessage', {
  showExternalErrorMessage
});

 })(window);